<template>
    <div>
        <div class="toolbar">
            <el-menu :default-active="menu_active" class="tool-menu" mode="horizontal" background-color="#fff" 
                text-color="#000" active-text-color="#000">
                <el-submenu index="1" popper-class="popper-menu">
                    <template slot="title">文件</template>

                    <el-submenu index="1-1">
                        <template slot="title">新建</template>
                        <el-menu-item index="1-1-0" @click="newFile('steam')">蒸汽</el-menu-item>
                        <el-menu-item index="1-1-1" @click="newFile('water')">水</el-menu-item>
                        <el-menu-item index="1-1-2" @click="newFile('compressed')">压缩空气</el-menu-item>
                    </el-submenu>

                    <el-submenu index="1-2">
                        <template slot="title">打开</template>
                        <el-menu-item index="1-2-0" v-if="saveFilesName.length<=0" >暂无文件</el-menu-item>

                        <el-menu-item :index="'1-2-'+index" v-for="item,index in saveFilesName" :key="index" @click="openFile(item)" class="menu-file-item">
                            <span class="menu-file">{{item}}</span>
                            <span class="menu-close" @click="e=>menuClose(item,e)"><i class="el-icon-close"></i></span>
                        </el-menu-item>

                        <el-divider></el-divider>
                        <el-menu-item :index="'1-2-'+saveFilesName.length" @click="uploadFile" >
                            <el-upload class="upload-demo" :action="apigateway+'/simulation/upload'" :on-success="handleOpenSuccess" 
                                :headers="headers" accept=".json" :data="{'type':'draw'}" :show-file-list="false" ref="upload">
                                本地文件
                            </el-upload>
                        </el-menu-item>

                    </el-submenu>

                    <el-menu-item index="1-3" @click="saveFile">保存</el-menu-item>

                    <el-menu-item index="1-4" @click="importFile">
                        <el-upload class="upload-demo" :action="apigateway+'/simulation/upload'" :on-success="handleImportSuccess" 
                            :headers="headers" accept=".json" :data="{'type':'import'}" :show-file-list="false" ref="import">
                            导入
                        </el-upload>
                    </el-menu-item>

                    <el-menu-item index="1-5" @click="exportFile">导出</el-menu-item>

                    <el-menu-item index="1-6" @click="print">打印</el-menu-item>
                    <a id="image-download" download="map.png"></a>

                    <el-submenu index="1-7">
                        <template slot="title">示例</template>
                        <el-menu-item index="1-1-0" @click="examples('steam')">蒸汽</el-menu-item>
                        <el-menu-item index="1-1-1" @click="examples('water')">水</el-menu-item>
                        <el-menu-item index="1-1-2" @click="examples('compressed')">压缩空气</el-menu-item>
                    </el-submenu>
                </el-submenu>

                <el-submenu index="2">
                    <template slot="title">编辑</template>
                    <el-menu-item index="2-1" @click="clearSource">清空</el-menu-item>
                    <el-menu-item index="2-2" @click="undo">撤销</el-menu-item>
                    <el-menu-item index="2-3" @click="redo">重做</el-menu-item>
                    <el-menu-item index="2-4" @click="openCodePanel">查看代码</el-menu-item>
                </el-submenu>
                <el-submenu index="3">
                    <template slot="title">计算</template>
                    <el-menu-item index="3-1" @click="simulate">仿真计算</el-menu-item>
                </el-submenu>
            </el-menu>

            <el-divider direction="vertical" class="divider"></el-divider>

            <div class="tool-item">
                <div class="tool-character overHeadParamSet" @click="settingClick('overHeadParamSet')">架空参数设置</div>
                <div class="tool-character" @click="settingClick('buriedParamSet')">地埋参数设置</div>
                <div class="tool-character" @click="settingClick('pipeParamSet')">管道参数</div>
                <div class="tool-character" @click="settingClick('insulaSchemeSet')">保温方案预设</div>
                <div class="tool-character" @click="settingClick('insulaMaterialSet')">保温材料预设</div>
                <div class="tool-character" @click="settingClick('tempePressRangeSet')">温压范围预设</div>
                <div class="tool-character" @click="settingClick('globalSet')">全局设置</div>
            </div>
        </div>
        
        <!--配置信息框-->
        <el-dialog
            :visible.sync="setting_dialog"
            :append-to-body="true"
            :modal="false"
            custom-class="setting-dialog"
            :close-on-click-modal="false"
            v-drag>

            <span slot="title" v-if="setting_active=='overHeadParamSet'">架空参数设置</span>
            <OverHeadParamSet class ="setting-content" v-if="setting_active=='overHeadParamSet'" @close="setting_dialog=false"/>

            <span slot="title" v-if="setting_active=='buriedParamSet'">地埋参数设置</span>
            <BuriedParamSet class ="setting-content" v-if="setting_active=='buriedParamSet'" @close="setting_dialog=false"/>

            <span slot="title" v-if="setting_active=='pipeParamSet'">管道参数</span>
            <PipeParamSet class ="setting-content" v-if="setting_active=='pipeParamSet'" @close="setting_dialog=false"/>

            <span slot="title" v-if="setting_active=='insulaSchemeSet'">保温方案预设</span>
            <InsulaSchemeSet class ="setting-content" v-if="setting_active=='insulaSchemeSet'" @close="setting_dialog=false"/>

            <span slot="title" v-if="setting_active=='insulaMaterialSet'">保温材料预设</span>
            <InsulaMaterialSet class ="setting-content" v-if="setting_active=='insulaMaterialSet'" @close="setting_dialog=false"/>

            <span slot="title" v-if="setting_active=='tempePressRangeSet'">温压范围预设</span>
            <TempePressRangeSet class ="setting-content" v-if="setting_active=='tempePressRangeSet'" @close="setting_dialog=false"/>

            <span slot="title" v-if="setting_active=='globalSet'">全局设置</span>
            <GlobalSet class ="setting-content" v-if="setting_active=='globalSet'" @close="setting_dialog=false"/>
        </el-dialog>

        <!--代码编辑框-->
        <el-dialog
            :visible.sync="code_dialog"
            :append-to-body="true"
            :modal="false"
            width="550px"
            custom-class="setting-dialog"
            :close-on-click-modal="false"
            v-drag>
                <span slot="title">代码编辑框</span>
                <codemirror ref="cmEditor_" class="cmEditor_flow" :style="{'height':'400px'}"/>
        </el-dialog>

        <!--文件保存对话框-->
        <el-dialog
            :visible.sync="filesave_dialog"
            :append-to-body="true"
            :modal="false"
            width="400px"
            custom-class="setting-dialog"
            :close-on-click-modal="false"
            v-drag>
                <span slot="title">文件保存对话框</span>

                <el-form ref="form" label-width="100px" class="attr_common" label-position="left">
                    <el-form-item label="文件名:">
                        <el-input v-model="fileName" class="input-box"></el-input>
                    </el-form-item>
                </el-form>
                <div class="foot-btn">
                    <el-button size="small" @click="saveFileOk">保存</el-button>
                </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import _remove from "lodash/remove";

/** 打开管道 */
import File from './PipeEditor/File';

import {calculateCenter} from '../utils/mapUtils'

/** 管道操作api */
import {savePipeline,getSaveFiles,open,delecteFile} from "@api/simulation"
import {getUserSetting} from "@api/map2d"

export default {
    data() {
        return {
            baseUrl:this.$store.state.assetsUrl, // 静态资源路径
            apigateway:process.env.VUE_APP_APIURL, // api网关
            menu_active:"1", // 菜单
            file:null , // 文件操作
            setting_dialog:false, // 设置面板
            setting_active:"", // 激活的设置面板

            code_dialog:false, // 代码显示面板
            filesave_dialog:false, // 文件保存对话框
            fileName:"", // 保存文件名
            saveFilesName:[], // 已保存的文件名称
        }
    },
    computed: {
        headers() {
            return {
                "Authorization": this.$store.getters.token
            }
        },
        ...mapState('simulation',[
            'map', // 当前地图组件
            'drawSource', // 当前绘图图层
            "nodes", // 全部节点的引用
            'simutype', // 计算介质类型
        ]),
        // 当前选中的组件
        curFeature(){
            return this.$store.state.simulation.curFeatures[0];
        }
    },
    watch:{
        // 地图
        map(){
            let file=new File(this.map);
            this.file=file;
        }
    },
    components:{
        OverHeadParamSet:()=>import('./PipeAttr/OverHeadParamSet.vue'), // 架空参数设置
        BuriedParamSet:()=>import('./PipeAttr/BuriedParamSet.vue'), // 地埋参数设置
        PipeParamSet:()=>import('./PipeAttr/PipeParamSet.vue'), // 管道参数设置
        InsulaSchemeSet:()=>import('./PipeAttr/InsulaSchemeSet.vue'), // 保温方案设置
        InsulaMaterialSet:()=>import('./PipeAttr/InsulaMaterialSet.vue'), // 保温材料预设
        TempePressRangeSet:()=>import('./PipeAttr/TempePressRangeSet.vue'), // 温压范围预设
        codemirror:()=>import("./Editor/JsonEditor"), // 代码查看器
        GlobalSet:()=>import("./PipeAttr/GlobalSet.vue"), // 全局配置
    },
    mounted(){
        this.$bus.$on("newFile",this.newFile); // 新键文件
        this.$bus.$on("saveFile",this.saveFile); // 保存文件
        this.$bus.$on("print",this.print); // 打印
        this.$bus.$on("uploadFile",this.uploadFile); // 打开文件
        // 进行数据初始化
        this.init_data();
    },
    methods: {
        // 初始化数据
        init_data(){
            // 获取后台数据，并对相应的内容进行初始化
            getUserSetting("simulation").then(res=>{
                if(res.status&&res.status==200){
                    let temp=res.content;
                    this.$store.commit("simulation/setGlobalConfig",temp);
                }
            });
            // 获取文件列表
            this.getFiles();
        },

        // 获取服务器文件列表
        getFiles(){
            // 获取保存的管道信息文件
            getSaveFiles().then(res=>{
                if(res.status&&res.status==200){
                    this.saveFilesName=res.content;
                }
            })
        },
        // 删除组件
        delectedCompontent(){
            let feature=this.curFeature;
            if(feature){
                // 删除相应的引用数组
                let _type=feature.get("_type");
                let nodes=[]; // 节点列表
                switch(_type){
                    case "input":
                        nodes=this.nodes["input"];
                        break;
                    case "unknownInput":
                        nodes=this.nodes["unknownInput"];
                        break;
                    case "output":
                        nodes=this.nodes["output"];
                        break;
                    default:
                        nodes=this.nodes["common"];
                        break;
                }
                if(nodes&&nodes.length>0){
                    nodes=_remove(nodes,item=>{
                        let id=item.get("id");
                        return id==feature.get("id");
                    });
                }

                // 删除地图上的内容
                let source=this.drawSource;
                source.removeFeature(feature);
            }
        },
        // 旋转组件
        rotateCompontent(){
            let feature=this.curFeature;
            if(feature){
                let geom=feature.getGeometry();
                const type = geom.getType();
                if(type !="Point"){ // 如果旋转的不是一个点
                    let center=calculateCenter(geom);
                    geom.rotate(90*Math.PI/180,center.center);
                    // 跟随线的点也应该一同改变位置
                }else{
                    let style=feature.getStyle();
                    let image=style.getImage();
                    // 设置旋转角度
                    let rotation=image.getRotation();
                    rotation+=90*Math.PI/180;
                    image.setRotation(rotation);
                    // 刷新样式
                    feature.setStyle(style);
                }

            }
        },
        // 保存文件
        saveFile(){
            // 打开文件保存对话框
            this.filesave_dialog=true;
        },
        // 保存文件确定
        saveFileOk(){
            // 处理文件名
            let filename=this.fileName;
            if(filename.indexOf(".json")<0){
                filename+=".json"
            }
            
            let filejson=this.file.save(); // 文件内容
            filejson=JSON.stringify(filejson);
            // 保存json
            savePipeline(filename,filejson).then(res=>{
                if(res.status&&res.status==200){
                    this.$message({
                        message:"文件保存成功",
                        type:"success",
                        duration:2000
                    });
                    // 关闭对话框
                    this.filesave_dialog=false;
                    // 增加文件
                    if(this.saveFilesName.indexOf(filename)<0){
                        this.saveFilesName.push(filename);
                    }
                }
            });
        },
        // 读取json文件
        openFile(filename){
            // 清空地图
            this.clearSource();
            // 获取文件内容
            open(filename).then(res=>{
                if(res.status&&res.status==200){
                    let fileJson=res.content;
                    this.file.open(fileJson);
                    // 启动地图事件
                    this.$bus.$emit("mapRestore");
                    // 切换地图模式，取消仿真
                    this.$store.commit("simulation/setMapMode","draw");
                }
            });
        },

        // 导出文件
        exportFile(){
            let filename="pipe_"+this.$moment().format('yyyyMMDDHHmmss')+".json"; // 文件名
            let filejson=this.file.export(); // 文件内容
            filejson=JSON.stringify(filejson);
            let response=JSON.stringify(filejson);
            // 去掉其中的反斜杠和前后两个双引号
            response=response.replaceAll("\\","");
            response=response.substring(1,response.length-1);
            // 导出
            const blob = new Blob([response], { type: 'application/json;charset=utf-8' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = [filename];
            a.click();
            window.URL.revokeObjectURL(url);
        },
        // 上传文件
        uploadFile(){
            // 手动触发导入，解决menu中的对话框不触发的问题。
            this.$refs.upload.$children[0].$refs.input.click();
        },
        // 导入文件
        importFile(){
            // 手动触发导入，解决menu中的对话框不触发的问题。
            this.$refs.import.$children[0].$refs.input.click();
        },
        // 清空地图
        clearSource(){
            this.$store.commit('simulation/setLines', []);
            this.$store.commit('simulation/setNodes', {
                "common":[] , // 通用节点列表
                "input":[], // 输入节点列表
                "unknownInput":[], // 待求输入节点列表
                "output":[], // 输出节点列表
            });
            this.drawSource.clear();
        },
        // 新键文件
        newFile(type){
            type=type||this.simutype;
            // 清空图层
            this.clearSource();
            // 仿真计算的介质类型
            this.$store.commit("simulation/setSimutype",type);
        },
        // 打开设置面板
        settingClick(name){
            this.setting_active=name;
            // 显示设置窗口
            this.setting_dialog=true;
        },
        // 打开代码编辑框
        openCodePanel(){
            this.code_dialog=true;
            // 设置属性值
            this.$nextTick(()=>{
                let codeM=this.$refs["cmEditor_"].codemirror;
                let data=this.file.export()||"";
                // 进行json格式化
                try{
                    codeM.setValue(JSON.stringify(data, null, 2));
                }catch{
                    codeM.setValue(data);
                }
                codeM.refresh();
            });
        },
        // 仿真计算
        simulate(){
            // 触发仿真事件
            this.$bus.$emit("simulate");
            // 启动仿真模式
            this.$store.commit("simulation/setMapMode","simulation");
        },
        // 撤销
        undo(){
            this.$store.commit("simulation/undo");
        },
        // 重做
        redo(){
            this.$store.commit("simulation/redo");
        },
        // 文件删除
        menuClose(item,e){
            e.preventDefault();
            e.stopPropagation();
            // 删除文件
            delecteFile(item).then(res=>{
                if(res.status&&res.status==200){
                    this.$message({
                        message:"文件删除成功",
                        type:"success",
                        duration:2000
                    });
                    // 删除文件数组中的值
                    var index = this.saveFilesName.indexOf(item);
                    if (index > -1) {
                        this.saveFilesName.splice(index, 1);
                    }
                }
            })
        },
        // 本地文件上传成功
        handleOpenSuccess(){
            // 重新获取文件列表
            this.getFiles();
        },
        // 文件导入成功
        handleImportSuccess(response){
            if(response.status&&response.status==200){
                let content=response.content;
                let filename=content.filename;
                // 清空地图
                this.clearSource();
                // 获取文件内容
                open(filename).then(res=>{
                    if(res.status&&res.status==200){
                        let fileJson=res.content;
                        // 执行文件导入
                        this.file.import(fileJson);
                        // 重新初始化地图内容
                        this.$bus.$emit("mapRestore");
                        // 切换地图模式，取消仿真
                        this.$store.commit("simulation/setMapMode","draw");
                    }
                });
            }else{
                this.$message({
                    type:"error",
                    message:"文件上传失败"
                })
            }
        },
        // 打印
        print(){
            let that=this;
            let map=this.map;
            map.once('rendercomplete', function () {
                const mapCanvas = document.createElement('canvas');
                const size = map.getSize();
                mapCanvas.width = size[0];
                mapCanvas.height = size[1];
                const mapContext = mapCanvas.getContext('2d');
                Array.prototype.forEach.call(
                    document.querySelectorAll('.ol-layer canvas'),
                    function (canvas) {
                        if (canvas.width > 0) {
                            const opacity = canvas.parentNode.style.opacity;
                            mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                            const transform = canvas.style.transform;
                            // Get the transform parameters from the style's transform matrix
                            const matrix = transform
                                .match(/^matrix\(([^\(]*)\)$/)[1]
                                .split(',')
                                .map(Number);
                            // Apply the transform to the export map context
                            CanvasRenderingContext2D.prototype.setTransform.apply(
                                mapContext,
                                matrix
                            );
                            mapContext.drawImage(canvas, 0, 0);
                        }
                    }
                );
                if (navigator.msSaveBlob) {
                    // link download attribute does not work on MS browsers
                    navigator.msSaveBlob(mapCanvas.msToBlob(), 'map.png');
                } else {
                    const link = document.getElementById('image-download');
                    link.href = mapCanvas.toDataURL();
                    link.click();
                }

                that.$message({
                    message:"图片已导出，请打开相关文件进行打印",
                    type:"success",
                    duration:2000
                });
            });
            map.renderSync();
        },

        // 示例
        examples(type){
            // 清空地图
            this.clearSource();
            let filename=type+".json"
            // 获取文件内容
            open(filename,"examples").then(res=>{
                if(res.status&&res.status==200){
                    let fileJson=res.content;
                    this.file.open(fileJson);
                    // 启动地图事件
                    this.$bus.$emit("mapRestore");
                }
            });
        },
    },
}
</script>

<style lang="scss">
.toolbar {
    height: 64px;
    line-height: 64px;
    background: #fff;
    border-bottom: 1px solid #ddd;
    padding-left: 5px;
    overflow: hidden;
    
    /** 菜单 */
    .tool-menu{
        border:none;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 4px;

        .el-submenu__title{
            border: none !important;;
        }
    }

    .divider{
        height: 50%;
        margin-right: 10px;
    }

    .tool-item{
        display: inline-block;
        font-size: 20px;

        .tool-icon{
            display: inline-block;
            padding:0 10px;
            cursor: pointer;
        }

        .tool-character{
            display: inline-block;
            font-size: 14px;
            padding:5px 10px;
            cursor: pointer;
        }
        .tool-character.active{
            color:cornflowerblue;
        }
    }

    .tool-item.disabled{
        color:#b3b2b2;
    }
}

/** 属性对话框 */
// .el-dialog__wrapper{
//     overflow: hidden;
// }
.setting-dialog{
    width: max-content;
    margin-top: 10vh!important;

    .el-dialog__header{
        padding: 5px 10px 5px 10px;
        color: #fff;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        background: #2c99db;

        .el-dialog__headerbtn{
            top: 5px;
            right: 5px;

            .el-dialog__close{
                color: #fff;
            }
        }

    }
    .el-dialog__body{
        padding:20px;
        min-height: 100px;
        position: relative;
        max-height: 700px;

        .el-form-item{
            margin-bottom:10px;
        }

        .el-input{
            width:150px;
            .el-input__inner{
                height: 35px;
                line-height: 35px;
            }

        }
        .el-input__suffix-inner{
            top: 50%;
            position: relative;
            transform: translateY(-50%);
            display: inline-block;
        }
        .el-button{
            span{
                cursor: pointer;
            }
        }

        .input-box{
            margin-right: 10px;
        }

        .foot-btn{
            text-align: right;
        }
    }
    /** 弹出面板内容 */
    .setting-content{
        width: 530px;

        /** 方案下拉按钮 */
        .input-with-select{
            margin-right: 10px;
            position: relative;
            z-index: 10;

            .el-input-group__append{
                padding:0 5px;

                .el-button{
                    padding:0 5px;
                    margin:0;
                }
            }
        }
        /** 方案列表 */
        .suggestions-list{
            position: absolute;
            z-index: 10;
            left: 0;
            top: 36px;
            border: 1px solid #eee;
            padding: 10px;
            width: 150px;
            background: #fff;
            overflow-x:hidden ;
            height: 200px;

            .select-item{
                cursor: pointer;
            }

            .select-item:hover{
                color:rgb(59, 138, 228);
            }
        }
    }
}

/** 弹出菜单 */
.popper-menu{
    .el-divider{
        margin:0;
    }

    .menu-file-item{
        position: relative;
        .menu-file{
            display: inline-block;
            width: 80%;
            overflow:hidden; //超出的文本隐藏
            text-overflow:ellipsis; //溢出用省略号显示
            white-space:nowrap; //溢出不换行
        }
        .menu-close{
            float: right;
            cursor: pointer;
        }
    }
   
}
</style>
